import { FiFormEditConfirmQuestionDeleteDialogComponent } from './../../fi-form/fi-form-edit/fi-form-edit-form/fi-form-edit-confirm-question-delete-dialog/fi-form-edit-confirm-question-delete-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DialogYesNoInputComponent } from './dialog-yes-no-input/dialog-yes-no-input.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, FiAppTextSharedModule],
    declarations: [DialogYesNoInputComponent, FiFormEditConfirmQuestionDeleteDialogComponent],
})
export class FiDialogModule {}
